export function getDeviceInfo() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera

    if (/android/i.test(userAgent)) {
        return { isMobile: true, os: "android" }
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return { isMobile: true, os: "ios" }
    } else if (/Mobi|Mobile/i.test(userAgent)) {
        return { isMobile: true, os: "unknown" } // mobile, mas não identificado
    } else {
        return { isMobile: false, os: "desktop" }
    }
}
